module.exports = __webpack_public_path__ + "static/media/seo.d3b6daf7.jpg";